import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Form, Row, Col } from "react-bootstrap";
import LoginOtp from "./LoginOtp";
import { useLoginMutation } from "store/services/auth";

// img
import logo from "Assets/images/logo.png";

// css
import styles from "layout/Auth/Auth.module.scss";
import { Formik } from "formik";
import loginFormSchema from "./LoginForm.schema";
import AppInputField from "components/shared/FormComponents/AppInputField";
import LoadingButton from "components/shared/LoadingButton";
import { Eye, EyeOff } from "react-feather";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loginSubmit, { isLoading }] = useLoginMutation();
  const [challenge, setChallenge] = useState(null);
  const [loginError, setLoginError] = useState("");

  const handleSubmit = async (values, { setSubmitting }) => {
    setLoginError("");
    try {
      const data = await loginSubmit({
        username: values.email,
        password: values.password,
        source: "admin"
      }).unwrap();
      if (!data?.otp_required || !data?.challenge_id) {
        setLoginError("Unable to start verification. Please log in again.");
        return;
      }
      setChallenge(data);
    } catch (err) {
      setLoginError(err?.data?.message || "Unable to log in. Please try again.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <>
      <div className="formInner position-relative px-lg-3">
        <div className="w-100 inner">
          <div className="top py-2 text-center">
            <img
              src={logo}
              alt=""
              className="img-fluid mb-3 object-fit-contain"
              style={{ height: 100 }}
            />
            <h4 style={{ color: "#b46c9f", fontSize: "21px", textDecoration: "underline" }} className="m-0 fw-sbold text-center">ADMIN LOGIN</h4>
          </div>
          {challenge ? (
            <LoginOtp challenge={challenge} onRestart={(message) => {
              setChallenge(null);
              setLoginError(message || "");
            }} />
          ) : <>
          {loginError && <p className="error mt-3" role="alert">{loginError}</p>}
          <Formik
            initialValues={{ email: '', password: '' }}
            validationSchema={loginFormSchema}
            onSubmit={handleSubmit}
          >
            {({
              handleSubmit,
              isSubmitting,
            }) => (
              <Form className={`${styles.form} pt-2`} onSubmit={handleSubmit}>
                <Row className="justify-content-center">
                  <Col lg="12" className="my-2">
                    <AppInputField
                      name="email"
                      placeholder="email"
                      className={`${styles.formControl} form-control`}
                    />
                  </Col>
                  <Col lg="12" className="my-2">
                    <div className="position-relative iconWithText">
                      <AppInputField
                        name="password"
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        className={`${styles.formControl} form-control`}
                      />
                      <Button
                        onClick={() => setShowPassword(!showPassword)}
                        className="border-0 p-0 position-absolute icn"
                        variant="transparent"
                        style={{ right: 10 }}
                      >
                        {showPassword ? <EyeOff size={18} color="#595959" /> : <Eye size={18} color="#595959" />}
                      </Button>
                    </div>
                  </Col>
                  <Col lg="12" className="my-2">
                    <div className="d-flex align-items-center justify-content-between gap-10">
                      <div className="left d-flex align-items-center gap-10">
                        {/* <input type="checkbox" className="form-check" />
                        <label htmlFor="" className="form-label m-0 text-muted">
                          Remember Password
                        </label> */}
                      </div>
                      <Link to="/forgot-password" className={`themeClr`}>
                        Forgot Password?
                      </Link>
                    </div>
                  </Col>
                  <Col lg="12" className="my-2">
                    <div className={`${styles.btnWrpper} pt-3 btnWrpper`}>
                      <LoadingButton
                        type="submit"
                        className="d-flex align-items-center justify-content-center w-100 commonBtn text-uppercase"
                        isLoading={isLoading}
                      >
                        Login
                      </LoadingButton>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
          </>}
        </div>
      </div>
    </>
  );
};
export default Login;
